'use strict';

/**
 * Common constants for all instances.
 */
const selectors = {
    countrySelect: '.js-address-country',
    postalCodeField: '.js-address-zipcode',
    streetField: '.js-address-address1',
    cityField: '.js-address-city',
    suggestionsContainer: '.js-address-address1-suggestions'
};
const allowedCountries = ['BE', 'DE'];
const requestTimeout = 500;
const maxResults = 5;
const suggestionClassName = 'js-suggestions-item';
const umlautCharacters = {
    ae: 'ä',
    oe: 'ö',
    ue: 'ü',
    Ae: 'Ä',
    Oe: 'Ö',
    Ue: 'Ü'
};
const umlautPattern = new RegExp(Object.keys(umlautCharacters).join('|'), 'g');

/**
 * The main function, which applies street suggestion functionality for the form.
 */
$.fn.applySuggestStreet = function () {
    const $instance = this;
    const $countrySelect = $instance.find(selectors.countrySelect);
    const $postalCodeField = $instance.find(selectors.postalCodeField);
    const $streetField = $instance.find(selectors.streetField);
    const $cityField = $instance.find(selectors.cityField);
    const $suggestionsContainer = $instance.find(selectors.suggestionsContainer);

    // skipping the initialization if at least one form element is missing
    if (!$countrySelect.length || !$postalCodeField.length || !$streetField.length || !$cityField.length || !$suggestionsContainer.length) {
        return;
    }

    let isEnabledSuggestStreet = false;
    let selectedCountry = null;
    let requestTimer = null;
    let lastStreetValue = null;

    /**
     * Clears the suggestions container and memorizes the last requested street value.
     * @param {string} streetValue - The street value to memorize.
     */
    function clearSuggestions(streetValue) {
        lastStreetValue = streetValue;
        $suggestionsContainer.addClass('d-none').empty();
    }

    /**
     * Internal handler for the 'change' event of the country select form element.
     */
    function onChangeCountrySelect() {
        selectedCountry = $(this).val().trim();
        isEnabledSuggestStreet = allowedCountries.includes(selectedCountry);

        if (isEnabledSuggestStreet) {
            $streetField.attr('autocomplete', 'off');
        }

        if (selectedCountry === 'DE') {
            $cityField.attr('readonly', true);
            $cityField.addClass('disabled');
        }

        clearSuggestions($streetField.val().trim());
    }

    /**
     * Internal handler for the suggestion selection.
     */
    function onSuggestionSelect() {
        const streetValue = $(this).text().trim();

        if (selectedCountry === 'DE') {
            $cityField.val($(this).data('city').trim());
        }

        $streetField.val(streetValue);
        clearSuggestions(streetValue);
        $streetField.trigger('keyup');
    }

    $countrySelect.on('change', onChangeCountrySelect);

    $postalCodeField.on('change', function () {
        if (!$(this).val().trim()) {
            clearSuggestions($streetField.val().trim());
        }
    });

    $streetField.on('keyup change', function () {
        if (selectedCountry === 'DE') {
            $(this).val($(this).val().replace(umlautPattern, match => umlautCharacters[match]));
        }
    });

    $streetField.on('focusout', function () {
        const $suggestions = $suggestionsContainer.find(`.${suggestionClassName}`);

        if ($suggestions.length === 1) {
            onSuggestionSelect.call($suggestions[0]);
        } else {
            $suggestionsContainer.addClass('d-none');
        }
    });

    $streetField.on('focusin', function () {
        if ($suggestionsContainer.find(`.${suggestionClassName}`).length) {
            $suggestionsContainer.removeClass('d-none');
        }
    });

    $streetField.on('keyup', function () {
        const streetValue = $(this).val().trim();
        const postalCodeValue = $postalCodeField.val().trim();

        if (!isEnabledSuggestStreet || !postalCodeValue || streetValue === lastStreetValue) {
            return;
        }

        clearTimeout(requestTimer);
        clearSuggestions(streetValue);

        if (!streetValue) {
            return;
        }

        const url = `https://api.pro6pp.nl/v2/suggest/${selectedCountry.toLowerCase()}/street`;
        const params = {
            authKey: window.pro6pp_auth_key,
            postalCode: postalCodeValue,
            street: streetValue,
            maxResults: maxResults
        };

        requestTimer = setTimeout(function () {
            $.ajax({
                url: url,
                data: params,
                dataType: 'json'
            }).done(function (data) {
                if (data && data.length) {
                    data.forEach(function (item) {
                        $suggestionsContainer.append(`<div class="${suggestionClassName}" data-city="${item.settlement}">${item.street}</div>`);
                    });

                    $suggestionsContainer.removeClass('d-none');
                }
            });
        }, requestTimeout);
    });

    $suggestionsContainer.on('mousedown touchstart', `.${suggestionClassName}`, onSuggestionSelect);

    // calling handler to set the initial state
    onChangeCountrySelect.call($countrySelect);
};
